import React, { useEffect, useState } from "react";
import ViewProfilePageComponent from "./viewProfilePage.page";
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import {AccessRights} from 'lib/constants/accessRights'
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function ViewProfilePageContainer() {
  const history = useHistory()
  const hasEmployeeViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Employee.READ));
  const lang = useSelector(state => state.constant.languages);
  
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if(!hasEmployeeViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasEmployeeViewAccessRight])

  if (!hasEmployeeViewAccessRight) return <LoadingComponent />;

  const tabLabels = [getLang(lang, "label.INFO_SETTING"), getLang(lang, "label.ORDER_HISTORY")];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  return (
    <>
      <ViewProfilePageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
      />
    </>
  );
}

export default ViewProfilePageContainer;
